import React, { useState } from 'react';

import {
  downloadReportPdf,
  generateSizeReport,
} from '../../services/reportService';


export function SizeReportActions({
  workflowRunId,
  pipeline,
  status,
  isValid,
}) {
  const [reportId, setReportId] = useState(null);
  const [generating, setGenerating] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const eligible =
    Boolean(workflowRunId) &&
    pipeline === 'size' &&
    status === 'completed' &&
    isValid === true;

  if (!eligible) {
    return null;
  }

  const handleGenerate = async () => {
    setGenerating(true);
    setError(null);
    try {
      const report = await generateSizeReport(workflowRunId);
      if (!report?.id) {
        throw new Error('Report generation response did not include a report ID.');
      }
      setReportId(report.id);
    } catch (requestError) {
      setError(requestError.message || 'Unable to generate report.');
    } finally {
      setGenerating(false);
    }
  };

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      await downloadReportPdf(reportId);
    } catch (requestError) {
      setError(requestError.message || 'Unable to download report.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-sm font-semibold text-slate-900">Size report</h3>
          <p className="mt-1 text-xs text-slate-500">
            Generate a static PDF from this completed saved run.
          </p>
        </div>
        {reportId ? (
          <button
            type="button"
            onClick={handleDownload}
            disabled={downloading}
            className="rounded bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Download PDF
          </button>
        ) : (
          <button
            type="button"
            onClick={handleGenerate}
            disabled={generating}
            className="rounded bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {generating ? 'Generating...' : 'Generate report'}
          </button>
        )}
      </div>
      {error && (
        <p role="alert" className="mt-3 text-sm text-rose-700">
          {error}
        </p>
      )}
    </div>
  );
}
